export default {
  auth: () => import("/home/runner/work/hub/hub/layouts/auth.vue").then(m => m.default || m),
  client: () => import("/home/runner/work/hub/hub/layouts/client.vue").then(m => m.default || m),
  default: () => import("/home/runner/work/hub/hub/layouts/default.vue").then(m => m.default || m),
  register: () => import("/home/runner/work/hub/hub/layouts/register.vue").then(m => m.default || m),
  simple: () => import("/home/runner/work/hub/hub/layouts/simple.vue").then(m => m.default || m),
  therapist: () => import("/home/runner/work/hub/hub/layouts/therapist.vue").then(m => m.default || m)
}